import servise from '@/router/axios'

// 分页查询广告主列表
export const getAdvertiserPage = (params) => {
  return servise({
    url: '/ocpx/advertiser/page',
    method: 'get',
    params
  })
}

// 根据ID查询广告主详情
export const getAdvertiserById = (id) => {
  return servise({
    url: `/ocpx/advertiser/${id}`,
    method: 'get'
  })
}

// 根据广告主编码查询
export const getAdvertiserByCode = (advertiserCode) => {
  return servise({
    url: `/ocpx/advertiser/code/${advertiserCode}`,
    method: 'get'
  })
}

// 新增广告主
export const addAdvertiser = (data) => {
  return servise({
    url: '/ocpx/advertiser',
    method: 'post',
    data
  })
}

// 更新广告主
export const updateAdvertiser = (data) => {
  return servise({
    url: '/ocpx/advertiser',
    method: 'put',
    data
  })
}

// 删除广告主
export const deleteAdvertiser = (id) => {
  return servise({
    url: `/ocpx/advertiser/${id}`,
    method: 'delete'
  })
}

// 更新广告主状态
export const updateAdvertiserStatus = (id, status) => {
  return servise({
    url: `/ocpx/advertiser/${id}/status/${status}`,
    method: 'put'
  })
}

// 查询所有启用的广告主
export const getEnabledAdvertiserList = () => {
  return servise({
    url: '/ocpx/advertiser/enabled/list',
    method: 'get'
  })
}
